<div class="map-container w-full bg-gray-400">

    <!-- Non Dispatch -->
    <div class="absolute ml-2 mt-2 w-96 z-10 bg-white rounded-lg" *ngIf="!isDispatch">
      <div class="relative rounded-md shadow-lg">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <mat-icon
                class="m-0 mr-1 icon-size-5 text-indigo-600"
                [svgIcon]="'heroicons_outline:search'">
          </mat-icon>
        </div>
        <input googleMapsAutocomplete (autocompleteSelected)="onAutocompleteSelected($event)" [(ngModel)]="searchAll"
        type="text" name="map-search" id="map-search" class="flex-1 min-w-0 block w-full h-12 px-3 py-2 pl-10 pr-10 rounded-none rounded-l-md sm:text-sm border-indigo-300" placeholder="{{'placeholder.enter_address' | translate}}">
        <div class="absolute inset-y-0 right-0 pl-3 flex-1 items-center pt-2 pr-1" *ngIf="searchAll">
          <button mat-icon-button class="min-w-7 max-w-7 min-h-7 max-h-7" (click)="clearMapSearch()"><em class="ti ti-x close-mark text-xl"></em></button>
        </div>
      </div>
    </div>

    <!-- Dispatch -->
    <div class="relative z-10  h-18 border-b border-gray-300 bg-white flex justify-between w-full" *ngIf="isDispatch">
      <!-- Search and action buttons -->
      <div class="flex items-center w-full" *ngIf="!drawOnMapNavbarData.toggleNavBar">
        <div class="w-full relative rounded-md items-center justify-center flex space-x-2">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <mat-icon
                  class="m-0 mr-1 icon-size-6 text-indigo-600"
                  [svgIcon]="'heroicons_outline:search'">
            </mat-icon>
          </div>
          <input googleMapsAutocomplete (autocompleteSelected)="onAutocompleteSelected($event)" [(ngModel)]="searchAll" autocomplete="off"
          type="text" name="map-search" id="map-search" class="flex-1 min-w-0 block w-full h-12 px-3 py-2 pl-10 pr-10 text-lg rounded-none rounded-l-md border-indigo-300" placeholder="{{'placeholder.enter_address' | translate}}">
          <div class="absolute inset-y-0 right-0 pl-3 flex-1 items-center flex py-2 pr-1" *ngIf="searchAll">
            <button mat-icon-button class="min-w-4 max-w-7 min-h-7 max-h-7" (click)="clearMapSearch()"><em class="ti ti-x close-mark text-xl mt-1"></em></button>
          </div>
        </div>
        <div class="flex px-4 py-3 content-center items-center justify-center">
          <button class="icon-button relative inline-flex items-center"
            title="{{'dispatchBoard.icons.tooltip.layers' | translate}}" (click)="setOptionState()"
            [ngxTippy]="tooltip_template" [tippyProps]="tippyProps">
            <i class="ti ti-stack text-2xl"></i>
          </button>
          <button class="icon-button relative inline-flex items-center" title="{{'text.filters' | translate}}" (click)="openFilter()"><i class="ti ti-filter text-2xl"></i>
          <div id="mapFilterBadge" class="absolute inline-flex items-center opacity-0 justify-center w-6 h-6 text-xs font-bold text-white bg-primary-600 border-2 border-white rounded-full -top-1 -right-2 z-99 dark:border-gray-900"></div>
          </button>
          <button class="icon-button relative inline-flex items-center" title="{{'text.settings' | translate}}" (click)="openSettings()"><i class="ti ti-settings text-2xl"></i></button>
        </div>
      </div>

      <!-- Route job selection nav bar -->
      <div class="flex items-center justify-center w-full mx-auto px-4" *ngIf="drawOnMapNavbarData.toggleNavBar">
        <div class="text-center">
          <span class="primary-font font-semibold">{{drawOnMapNavbarData.selectedJobs.length}} {{'jobs.selected' | translate}}</span>
        </div>
        <div class="flex ml-auto mr-2 order-2 space-x-4">
          <button type="button"
          (click)="clearDrawOnMap()"
            class="px-4 py-3 h-9 flex gap-2 cursor-pointer text-base items-center text-gray-700 border b-1 border-gray-300 shadow-xs font-medium rounded-md bg-white focus:outline-none btn-small">
            {{'cancel.text' | translate}}</button>
          <button type="button" (click)="createRouteOnDraw()"
            class="bg-primary text-base px-4 py-3 cursor-pointer h-9 w-max flex gap-2 items-center border-gray-300 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none">
            {{'route.create' | translate}}</button>
        </div>
      </div>
    </div>

    <div id="map">
      <div class="px-2.5 py-2 rounded bg-blue-500 text-white text-center absolute shadow-md top-4 map-draw-float-btn z-999 w-fit primary-font text-base font-normal"
        *ngIf="floatingActionButton.showInfo && !floatingActionButton.showClearBtn">
        {{floatingActionButton.infoMessage}}
      </div>
      <div class="px-2.5 py-2 rounded-3xl flex items-center space-x-2 font-medium shadow-md text-gray-700 bg-white text-center absolute top-4 map-draw-float-btn z-999 w-fit primary-font text-base cursor-pointer"
       [ngClass]="!floatingActionButton.showClearBtn || floatingActionButton.showInfo ? 'hidden': ''" (click)="clearDrawOnMap(false, true)">
        <i class="ti ti-x text-2xl text-gray-400"></i>
        <span>{{'text.clear_selection' | translate}}</span>
      </div>
      <div class="ml-2 absolute bottom-2 tile-layer-parent" >
        <span class="w-12 h-12 tile-layer-satellite cursor-pointer border-2 border-gray-500 shadow-md rounded-md" *ngIf="currentTitleType === 'DEFAULT'" title="{{'satellite.view' | translate}}" (click)="setTileLayer('SATELLITE', $event)"></span>
        <span class="w-12 h-12 tile-layer-default cursor-pointer border-2 border-gray-500 shadow-md rounded-md"  *ngIf="currentTitleType === 'SATELLITE'"  title="{{'map.view' | translate}}"  (click)="setTileLayer('DEFAULT', $event)"></span>
      </div>
    </div>
    <preview-data [drawerOpen]="openDrawer" [module]="drawerModule" class="map-preview-data"
            [moduleUID]="moduleUid" [options]="previewOptions" (eventEmitter)="previewDataEventHandler($event)">
    </preview-data>
</div>

<ng-template #tooltip_template let-hide>
    <div class="primary-font text-base text-gray-700">
        <div class="w-56 flex flex-col">
            <ng-container *ngFor="let option of pinOptions">
                <div *ngIf="option?.showModule" 
                    class="flex items-center justify-between cursor-pointer hover:bg-gray-100 px-3 py-2.5"
                    (click)="pinOptionChange(option.key)">
                    <div class="flex items-center w-full">
                        <div class="w-8 flex justify-center">
                            <i class="ti text-2xl" [ngClass]="option?.icon"></i>
                        </div>
                        <span class="font-normal ml-2 flex-1">
                            {{option.displayName | translate}}
                        </span>
                    </div>
                    <input type="checkbox" 
                        (change)="pinOptionChange(option.key)"
                        [checked]="getPinValue(option.key)"
                        class="w-4 h-4 text-primary bg-gray-100 border-gray-300 rounded focus:ring-primary">
                </div>
            </ng-container>
            <div class="p-4">
                <button class="w-full bg-primary hover:bg-primary-dark text-white font-medium px-6 py-2.5 rounded-md transition-colors duration-200"
                    type="button" 
                    (click)="savePinState()">
                    {{'text.apply' | translate}}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<zuper-drawer
    class="territory-drawer absolute top-16 right-0"
    [fixed]="true"
    [mode]= "'side'"
    [name]="'legendDrawer'"
    [position]="'right'"
    [transparentOverlay]="false"
    [hideOnClickOutside]="false"
    >
    <div class="w-full h-full">
      <div class="fade h-full w-full">
         <div class="border-b border-gray-300 flex justify-between zuper-dialog-header">
           <div class="primary-font font-bold text-xl text-gray-700 flex items-center pl-2">
               {{'dispatchBoard.icons.tooltip.legend' | translate}}
           </div>
           <div class="flex justify-around">
               <a class="h-10 w-10 flex justify-center items-center hover:bg-gray-200 rounded-full cursor-pointer" (click)="closeLegendDrawer()">
                   <em class="ti ti-x text-gray-900 text-xl"></em>
               </a>
           </div>
         </div>
           
         <div class="bg-white primary-font p-6 legend-container overflow-auto zuper-scrollbar legend-container-scroll">
           <div *ngFor="let territory of serviceTerritory" class="flex items-center mb-2">
            <span class="block rounded-full w-3 h-3 min-w-3 min-h-3" [ngStyle]="{'background': territory?.territory_color}"></span>
            <span class="ml-2 cursor-pointer" (click)="moveToTerritory(territory)">{{territory?.territory_name}}</span>
           </div>
           <div class="flex items-center justify-center w-full h-full" *ngIf="!serviceTerritory?.length">
              <span class="text-base font-normal">{{'no_data_found' | translate}}</span>
           </div>
         </div>

         <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer space-x-4">
            <button type="button" mat-stroked-button class="px-6 w-24 btn-small items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none" (click)="closeLegendDrawer()">{{'close.text' | translate}}</button>
          
        </div>
       </div>
   </div>
</zuper-drawer>

<ng-template #routeAddJobConfirmationDialogContent let-hide let-data>
  <div mat-dialog-title
      class="primary-font flex justify-between border-b border-b-gray-300 zuper-dialog-header mb-0">
      <h2>{{'text.add_job_to.route' | translate}} - {{data?.selectedRoute?.route_name || ''}}</h2>
      <button mat-icon-button aria-label="close dialog" (click)="closeAddJobConfirmationDialog()" tabindex="-1">
          <mat-icon>close</mat-icon>
      </button>
  </div>
  <div
      class="w-full h-full overflow-y-auto zuper-scrollbar primary-font font-normal text-base text-gray-700">
      <div class="relative overflow-y-auto flex flex-col space-y-4 p-4">
          <div class="primary-font font-normal text-base text-gray-700">
            <span>{{'dispatchBoard.map.add_job_to_route.confirmation' | translate}} <span class="font-medium"></span>{{data?.selectedRoute?.route_name || ''}}</span>
          </div>

          <div class="flex flex-col space-y-4" *ngIf="data?.selectedJobs?.length">
            <span class="font-semibold">{{routeJobConfirmationDialogData.selectedJobCount}} {{'jobs.selected' | translate}}</span>
            <div class="max-h-72 overflow-y-auto zuper-scrollbar flex flex-col space-y-4 border rounded">
                <div class="text-base font-normal primary-font text-gray-700 flex flex-col">
                  <div class="flex items-center" *ngFor="let job of data?.selectedJobs; let i=index;" [ngClass]="{'border-b': i !== data?.selectedJobs?.length - 1 }">
                    <div class="p-3">
                      <input id="{{job?.job_uid}}" type="checkbox" (change)="addRouteJobSelectionChange($event, job)"
                        [checked]="routeJobConfirmationDialogData.jobs[job?.job_uid]"
                        class="h-4 w-4 mt-0.5 border-gray-300 text-indigo-600">
                    </div>
                    <label for="{{job?.job_uid}}" class="flex flex-col cursor-pointer w-full ml-2">
                      <div class="flex w-full">
                        <div class="flex items-center justify-between p-3 pl-0" style="width: 65% !important; max-width: 65% !important;">
                          <div class="flex items-center space-x-2 truncate">
                            <div class="block truncate flex-1 max-w-180" title="{{job?.name}}">{{job?.name || ''}}</div>
                            <div *ngIf="job?.current_job_status?.status_name && job?.current_job_status?.status_color"
                              [ngStyle]="{'border': '1px solid ' + job?.current_job_status?.status_color, 'background': job?.statusFadeColor }"
                              class="rounded-xl min-w-fit flex space-x-1 px-1.5 items-center flex-0">
                              <div class="w-2.5 h-2.5 rounded-full" [style.background]="job?.current_job_status?.status_color"></div>
                              <div [style.color]="job?.current_job_status?.status_color">{{job?.current_job_status?.status_name}}</div>
                            </div>
                          </div>
                          <div [innerHTML]="job?.assignedToAvatar | safeHtml: false" class="min-w-fit flex-0"></div>
                        </div>
                        <div class="border-l flex-0" style="width: 35% !important;">
                          <div class="flex space-x-2 p-3" title="{{'text.scheduled_date'| translate}}" *ngIf="!job?.showDueDate">
                            <i class="ti ti-calendar text-2xl" style="vertical-align: middle;"></i>
                            <span>
                              {{job?.startEndTime[0]}}
                              <i class="ti ti-arrow-right text-2xl" style="vertical-align: middle;"></i>
                              {{job?.startEndTime[1]}}
                            </span>
                          </div>
                          <div title="{{'text.due_by'| translate}}" class="flex items-center space-x-2 p-3" *ngIf="job?.showDueDate">
                            <i class="ti ti-calendar-due text-2xl"></i>
                            <div class="mt-0.5">{{job?.dueDate}}</div>
                          </div>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
            </div>
        </div>
      </div>
  </div>
  <div
      class="flex justify-end border-t border-gray-300 zuper-dialog-footer primary-font font-normal text-base text-gray-700">
      <div class="flex justify-around space-x-4">
          <button type="button" (click)="closeAddJobConfirmationDialog()" [disabled]="isRouteMoveInProgress"
              class="px-6 items-center py-2 border b-1 border-gray-300 text-black shadow-sm text-lg font-small rounded-md bg-white focus:outline-none btn-small">
              {{'close.text' | translate}}</button>
          <button (click)="onRouteAddJobCompleted()" [disabled]="!routeJobConfirmationDialogData.selectedJobCount" [ngClass]="{'default-hover opacity-70 cursor-not-allowed': !routeJobConfirmationDialogData.selectedJobCount}"
              class="flex min-w-24 btn-small px-6 items-center py-2 border text-base b-1 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary">
              <span class="text-white">Add {{routeJobConfirmationDialogData.selectedJobCount}} {{routeJobConfirmationDialogData.selectedJobCount > 1? 'jobs': 'job'}} to route</span>
          </button>
      </div>
  </div>
</ng-template>

<app-new-job [openDrawer]="openJob" [jobData]="jobData" [jobObject]="jobObject"  (jobFormEmitter)="getJobFormResult($event)"></app-new-job>

<app-route-form [options]="routeFormOption" [openPicker]="openNewRoute" [data]="currentRoute" (actionComplete)="onNewActionComplete($event)" [showRouteAlert]="true" [parentModule]="isDispatch ? 'dispatch': ''" [timezone]="routeCreationTimezone"></app-route-form>